import type { GatsbyBrowser } from 'gatsby';

declare global {
  interface Window {
    dataLayer: any[];
  }
}

export const onRouteUpdate: GatsbyBrowser['onRouteUpdate'] = ({
  location,
  prevLocation,
}) => {
  window.dataLayer = window.dataLayer || [];

  window.dataLayer.push({
    event: `PageTracker`,
    page_name: document.title || location.pathname,
    page_url: location.href,
    page_referrer: prevLocation ? prevLocation.href : document.referrer,
  });
};
